
import './IsckonCal.scss';

const lunarMonths = [
  'Vishnu Masa (Chaitra)', 'Madhusudana Masa (Vaishakha)', 'Trivikrama Masa (Jyeshtha)', 'Vamana Masa (Ashadha)',
  'Shridhara Masa (Shravana)', 'Hrishikesha Masa (Bhadra)', 'Padmanabha Masa (Ashvina)', 'Damodara Masa (Kartika)',
  'Keshava Masa (Margashirsha)', 'Narayana Masa (Pausha)', 'Madhava Masa (Magha)', 'Govinda Masa (Phalguna)'
];

const nakshatras = [
  'Ashvini', 'Bharani', 'Krittika', 'Rohini', 'Mrigashira', 'Ardra', 'Punarvasu', 'Pushyami', 'Ashlesha',
  'Magha', 'Purva Phalguni', 'Uttara Phalguni', 'Hasta', 'Chitra', 'Swati', 'Vishakha', 'Anuradha', 'Jyeshtha',
  'Mula', 'Purva Ashadha', 'Uttara Ashadha', 'Shravana', 'Dhanishtha', 'Shatabhisha', 'Purva Bhadra', 'Uttara Bhadra', 'Revati'
];

const yogas = [
  'Vishkumbha', 'Priti', 'Ayushmana', 'Saubhagya', 'Shobana', 'Atiganda', 'Sukarma', 'Dhriti', 'Shula', 'Ganda',
  'Vriddhi', 'Dhruva', 'Vyagata', 'Harshana', 'Vajra', 'Siddhi', 'Vyatipata', 'Variyana', 'Parigha', 'Shiva',
  'Siddha', 'Sadhya', 'Shubha', 'Shukla', 'Brahma', 'Indra', 'Vaidhriti'
];

const IsckonCal = () => {
  return (
    <div className="iskcon-calendar">
      <h1>ISKCON Calendar</h1>
      <p className="description">
        This Vaisnava Calendar for ISKCON has been created independent of Gaurabda Calendar or GCal published by
        GBC Vaisnava Calendar Committee of the International Society for Krishna Consciousness (ISKCON).
        However, it follows the same rules as those followed by GCal. Ideally both calendars should match and
        if you find any mismatch it might be due to software error in either of the software.
      </p>

      <div className="section">
        <h2>Lunar Month List</h2>
        <ul>
          {lunarMonths.map((month, index) => (
            <li key={index}>{month}</li>
          ))}
        </ul>
      </div>

      <div className="section">
        <h2>Nakshatra List</h2>
        <ul>
          {nakshatras.map((nakshatra, index) => (
            <li key={index}>{nakshatra}</li>
          ))}
        </ul>
      </div>

      <div className="section">
        <h2>Yoga Names</h2>
        <ul>
          {yogas.map((yoga, index) => (
            <li key={index}>{yoga}</li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default IsckonCal;
